import i18n from "../../../../i18n/i18n";

/**
 * last and news list of Messages global uses
 */
var validationMessage=[];

/**
 * 
 */
 const EntrykeysValidationMessage = {
    RequiredWarehouse:'RequiredWarehouse',
    RequiredMaterial:'RequiredMaterial',
    RequiredQuantity:'RequiredQuantity',
    RequiredCost:'RequiredCost',
}


/**
 * dictionary contain message
 * flang is= fisrt language  , slanf is secound langauge 
 */
const EntryValidationMessage = {
    RequiredWarehouse: { ar: "إدخال المستودع مطلوب", en: "Warehouse is required ", es: 'Se requiere almacén' },
    RequiredMaterial: { ar: "إدخال المادة مطلوب", en: "Item is required", es: 'Se requiere artículo' },
    RequiredQuantity: { ar: "إدخال الكمية مطلوب", en: "Quantity is required", es: 'Se requiere cantidad' },
    RequiredCost: { ar: "إدخال الكلفة مطلوب", en: "Cost is required", es: 'Se requiere costo' },
};


function pushMessage(key){
    let message= EntryValidationMessage[key][i18n.locale];
    if(!validationMessage.includes(message)){
        validationMessage.push(message);
    }
}

/**
 * Detected change entry row of founds table and enabled valid scenarios.
 *
 * @param {Object} entry entry object .
 * @param {Object} linkedRules dictionary of rules.
 * @return {Array} array of validationMessages.
 */
export function entryDetectedValidation(entry){
    validationMessage = [];  //clear old =0

    // prevenet inter income amount and outcome amount in the same time
    // warehouse
    if(!entry.warehouse_id){
        pushMessage(EntrykeysValidationMessage.RequiredWarehouse);
    }
    
    // Material
    if(!entry.material_id){
        pushMessage(EntrykeysValidationMessage.RequiredMaterial);
    }

    if(!entry['quantity.quantity'] && !entry.quantity){
        pushMessage(EntrykeysValidationMessage.RequiredQuantity);
    }
    // cost
    if(!entry.cost){
        pushMessage(EntrykeysValidationMessage.RequiredCost);
    }
    return validationMessage;
}